// Generated by ReScript, PLEASE EDIT WITH CARE

import * as I18n from "../../primitives/I18n.res.js";
import * as Belt_Array from "@rescript/runtime/lib/es6/Belt_Array.js";
import * as SelectTsx from "./Select.tsx";
import * as Stdlib_Array from "@rescript/runtime/lib/es6/Stdlib_Array.js";
import * as Stdlib_Option from "@rescript/runtime/lib/es6/Stdlib_Option.js";
import * as Primitive_object from "@rescript/runtime/lib/es6/Primitive_object.js";
import * as Primitive_option from "@rescript/runtime/lib/es6/Primitive_option.js";
import * as JsxRuntime from "react/jsx-runtime";

function toFlatItem(item) {
  if (item.TAG === "Option") {
    return {
      key: item.key,
      label: item.label,
      value: Primitive_option.some(item.value),
      disabled: item.disabled,
      exclusive: item.exclusive,
      endElement: item.endElement
    };
  } else {
    return {
      key: item.key,
      label: item.label,
      items: item.items.map(toFlatItem),
      disabled: item.disabled,
      endElement: item.endElement
    };
  }
}

function flattenItems(items) {
  return items.flatMap(item => {
    if (item.TAG === "Option") {
      return [item];
    } else {
      return Belt_Array.concatMany([
        [item],
        flattenItems(item.items)
      ]);
    }
  });
}

let make = SelectTsx.FooterAction;

let FooterAction = {
  make: make
};

let make$1 = SelectTsx.Select;

function findKeyByValue(items, value) {
  return Stdlib_Array.reduce(items, undefined, (acc, item) => {
    if (acc !== undefined) {
      return acc;
    } else if (item.TAG === "Option") {
      if (Primitive_object.equal(item.value, value)) {
        return item.key;
      } else {
        return;
      }
    } else {
      return findKeyByValue(item.items, value);
    }
  });
}

function findValueByKey(items, key) {
  return Stdlib_Array.reduce(items, undefined, (acc, item) => {
    if (acc !== undefined) {
      return acc;
    } else if (item.TAG === "Option") {
      if (item.key === key) {
        return Primitive_option.some(item.value);
      } else {
        return;
      }
    } else if (item.key === key) {
      return;
    } else {
      return findValueByKey(item.items, key);
    }
  });
}

function Select(props) {
  let onChange = props.onChange;
  let value = props.value;
  let sections = props.sections;
  let __searchPlaceholder = props.searchPlaceholder;
  let searchPlaceholder = __searchPlaceholder !== undefined ? __searchPlaceholder : I18n.t("Search");
  let multiple;
  multiple = value.TAG !== "Single";
  let allItems = flattenItems(sections.flatMap(section => section.items));
  let findItemByKey = key => allItems.find(item => item.key === key);
  let values;
  values = value.TAG === "Single" ? [value._0] : value._0;
  let selectedKeys = Stdlib_Array.filterMap(values, value => findKeyByValue(allItems, value));
  let onSelectionChange = keys => {
    if (value.TAG === "Single") {
      return Stdlib_Option.forEach(Stdlib_Option.flatMap(keys[0], key => findValueByKey(allItems, key)), value => onChange({
        TAG: "Single",
        _0: value
      }));
    } else {
      return onChange({
        TAG: "Multiple",
        _0: Stdlib_Array.filterMap(keys, key => findValueByKey(allItems, key))
      });
    }
  };
  let shouldSelectTogether = Stdlib_Option.map(props.shouldSelectTogether, predicate => ((key, other) => {
    let match = findValueByKey(allItems, key);
    let match$1 = findValueByKey(allItems, other);
    if (match !== undefined && match$1 !== undefined) {
      return predicate(Primitive_option.valFromOption(match), Primitive_option.valFromOption(match$1));
    } else {
      return true;
    }
  }));
  let flatSections = sections.map(section => ({
    items: section.items.map(toFlatItem),
    title: section.title
  }));
  let renderItem = Stdlib_Option.map(props.renderItem, render => (args => {
    let item = findItemByKey(args.item.key);
    if (item !== undefined) {
      return render({
        item: item,
        isSubmenuTrigger: args.isSubmenuTrigger,
        isSelected: args.isSelected,
        isFocused: args.isFocused,
        isDisabled: args.isDisabled
      });
    } else {
      return null;
    }
  }));
  let mapTriggerRender = render => (args => render({
    selectedItems: Stdlib_Array.filterMap(args.selectedItems, flat => findItemByKey(flat.key)),
    active: args.active,
    hovered: args.hovered,
    focused: args.focused
  }));
  let renderValue = Stdlib_Option.map(props.renderValue, mapTriggerRender);
  let renderTrigger = Stdlib_Option.map(props.renderTrigger, mapTriggerRender);
  return JsxRuntime.jsx(make$1, {
    label: props.label,
    placeholder: props.placeholder,
    searchPlaceholder: searchPlaceholder,
    noResultFoundText: props.noResultFoundText,
    preset: props.preset,
    sections: flatSections,
    selectedKeys: selectedKeys,
    onSelectionChange: onSelectionChange,
    shouldSelectTogether: shouldSelectTogether,
    multiple: multiple,
    searchable: props.searchable,
    size: props.size,
    highlighted: props.highlighted,
    defaultOpen: props.defaultOpen,
    disabled: props.disabled,
    loading: props.loading,
    onSearch: props.onSearch,
    onLoadMore: props.onLoadMore,
    onToggle: props.onToggle,
    renderValue: renderValue,
    renderTrigger: renderTrigger,
    renderItem: renderItem,
    footerElement: props.footerElement
  });
}

let make$2 = Select;

export {
  FooterAction,
  make$2 as make,
}
/* make Not a pure module */
